export function getAspectRatio(
  forceAspectRatio: { width: number; height: number } | undefined,
  ratioWidth: number | null,
  ratioHeight: number | null,
): { width: number; height: number } | undefined {
  if (forceAspectRatio) {
    return forceAspectRatio;
  }

  if (!ratioWidth) {
    ratioWidth = 1;
  }
  if (!ratioHeight) {
    ratioHeight = 1;
  }
  const ratio = ratioWidth / ratioHeight;
  return Number.isFinite(ratio) && ratio > 0
    ? { width: ratioWidth, height: ratioHeight }
    : { width: 1, height: 1 };
}

export function getAspectRatioValue(
  ratio: { width: number; height: number } | undefined,
): number | undefined {
  if (!ratio) {
    return undefined;
  }
  return ratio.width / ratio.height;
}
